/**
 * Generate a unique event ID for Meta Pixel event deduplication
 * This ID is used to match browser events with server-side Conversions API events
 */
export const generateEventId = (): string => {
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 11);
  return `${timestamp}-${randomPart}`;
};
